import { WidgetIndexEntry } from '../core/domain/widget-index-entry';

/**
 * Which `widgetIndex` entry the booking should be on after the index emits.
 *
 * The root `widget/{uid}` doc is rewritten by unrelated edits (a dashboard rename reindexes it),
 * so a re-emission must not move a customer who has already picked a category. Order of
 * preference: the local widget's own category, then the category currently loaded (matched by
 * id, so a renamed category keeps the booking), then "Residential", then the first entry.
 * Returns -1 only for an empty index.
 */
export function pickCategoryIndex(
  widgetIndex: WidgetIndexEntry[] | null | undefined,
  options: { localWidgetKey?: string | null; currentWidgetId?: string | null },
): number {
  if (!Array.isArray(widgetIndex) || widgetIndex.length === 0) return -1;

  const byId = (id: string | null | undefined) =>
    id ? widgetIndex.findIndex((entry) => entry?.widgetId === id) : -1;

  // A local widget is pinned to its own category (unknown key: first entry, as before).
  if (options.localWidgetKey) {
    const local = byId(options.localWidgetKey);
    return local < 0 ? 0 : local;
  }

  let i = byId(options.currentWidgetId);
  if (i < 0) i = widgetIndex.findIndex((entry) => entry?.inspectionType === 'Residential');
  return i < 0 ? 0 : i;
}
